export const INTERLINK_TYPE = {
	STARTS: "starts",
	ENDS: "ends",
	WITH: "with",
	LENGTH: "length",

	WITH_IN_RESPONSE: "contains",
};

export const INTERLINK_SPECIAL_CASE = {
	FALLBACK: "FALLBACK",
	LENGTH_4: "LENGTH_4",
	LENGTH_5: "LENGTH_5",
	LENGTH_5_NO_STARTS: "LENGTH_5_NO_STARTS",
	LENGTH_5_NO_ENDS: "LENGTH_5_NO_ENDS",
	LENGTH_5_NO_WITH: "LENGTH_5_NO_WITH",
	LENGTH_6: "LENGTH_6",
	LENGTH_7: "LENGTH_7",
	LENGTH_8: "LENGTH_8",
};
